import { FormControl, MenuItem, Select } from '@material-ui/core'
import React, { useState } from 'react'

import { AreaLabelResponse, PolicyRule_ProrationKindEnum } from 'src/api/gen'
import { getTranslation } from 'src/commons/i18n'
import { ConfirmationDialogField } from 'src/pages/FeeRates/Editor/fields'

import { ProrationActions } from './ProrationActions'
import { ProrationAreasContent } from './ProrationAreasContent'
import { ProrationTimeSpentContent } from './ProrationTimeSpentContent'

interface IProrationFieldProps {
  areas: AreaLabelResponse[]
  disabled?: boolean
  handleProrationChange: (val: {
    proration_areas_mapping: Record<string, number> | undefined
    proration_kind: PolicyRule_ProrationKindEnum | undefined
    proration_time_spent_report_area: string | undefined
  }) => void
  prorationAreasMapping: Record<string, number> | undefined
  prorationKind: PolicyRule_ProrationKindEnum | undefined
  prorationTimeSpentReportArea: string | undefined
}

export const ProrationField = function (props: IProrationFieldProps) {
  const { t } = getTranslation()
  const [prorationKind, setProrationKind] = useState<PolicyRule_ProrationKindEnum | ''>(props.prorationKind ?? '')
  const [prorationAreasMapping, setProrationAreasMapping] = useState<[string, number][]>(
    props.prorationAreasMapping ? Object.entries(props.prorationAreasMapping) : [['', 0]]
  )
  const [prorationTimeSpentReportArea, setProrationTimeSpentReportArea] = useState(
    props.prorationTimeSpentReportArea ?? ''
  )

  let content = null
  if (prorationKind === PolicyRule_ProrationKindEnum.areas) {
    content = (
      <ProrationAreasContent
        areas={props.areas}
        disabled={props.disabled}
        prorationAreasMapping={prorationAreasMapping}
        setProrationAreasMapping={setProrationAreasMapping}
      />
    )
  } else if (prorationKind === PolicyRule_ProrationKindEnum.time_spent) {
    content = (
      <ProrationTimeSpentContent
        areas={props.areas}
        disabled={props.disabled}
        prorationTimeSpentReportArea={prorationTimeSpentReportArea}
        setProrationTimeSpentReportArea={setProrationTimeSpentReportArea}
      />
    )
  }

  return (
    <ConfirmationDialogField
      disabled={props.disabled}
      confirmationText="confirmation"
      openButtonTitle={t('buttons.edit.proration')}
      closeButtonTitle={t('buttons.close')}
      dialogContent={
        <>
          <FormControl style={{ minWidth: 120 }}>
            <Select
              disabled={props.disabled}
              value={prorationKind}
              onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) =>
                setProrationKind(event.target.value as PolicyRule_ProrationKindEnum)
              }
              displayEmpty
            >
              <MenuItem value={''}>
                <em>{t('No proration')}</em>
              </MenuItem>
              <MenuItem value={PolicyRule_ProrationKindEnum.areas}>{t('Fixed proration')}</MenuItem>
              <MenuItem value={PolicyRule_ProrationKindEnum.time_spent}>{t('Proration based on time spent')}</MenuItem>
            </Select>
          </FormControl>
          <br></br>
          {content}
        </>
      }
      dialogActions={(close, handleClose, openConfirm) => (
        <ProrationActions
          prorationKind={prorationKind}
          prorationAreasMapping={prorationAreasMapping}
          prorationTimeSpentReportArea={prorationTimeSpentReportArea}
          close={close}
          handleClose={handleClose}
          openConfirm={openConfirm}
        />
      )}
      onClose={() => {
        switch (prorationKind) {
          case '': {
            props.handleProrationChange({
              proration_kind: undefined,
              proration_areas_mapping: undefined,
              proration_time_spent_report_area: undefined,
            })
            break
          }
          case PolicyRule_ProrationKindEnum.areas: {
            const prorationAreasMappingDict = Object.fromEntries(prorationAreasMapping)

            props.handleProrationChange({
              proration_kind: prorationKind,
              proration_areas_mapping: prorationAreasMappingDict,
              proration_time_spent_report_area: undefined,
            })
            break
          }
          case PolicyRule_ProrationKindEnum.time_spent: {
            props.handleProrationChange({
              proration_kind: prorationKind,
              proration_areas_mapping: undefined,
              proration_time_spent_report_area: prorationTimeSpentReportArea,
            })
            break
          }
        }
      }}
    />
  )
}
